import { createAction, props } from '@ngrx/store';
import { ISettingsState } from './settings.state';

export const initSettingsAction = createAction('[Settings Page] Home page');

export const setSettingsAction = createAction(
  '[Settings Page] set settings',
  props<ISettingsState>()
);
